<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">

        <v-btn 
            color="#009ddc" 
            small 
            dark 
            fab  
            v-on="on"
        >
            <v-icon small>phone</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Registar interação</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
                <v-col cols="12">
                    <v-select
                        :items="resultados"
                        item-text="label"
                        item-value="value"
                        label="Resultado"
                        v-model="resultado"
                    ></v-select>
                </v-col>
                <v-col cols=12>
                    <v-datetime-picker 
                        label="Agendar contacto"
                        clearText="Limpar"
                        okText="Guardar"
                        dateFormat="yyyy-MM-dd"
                        timeFormat="HH:mm"
                        v-model="dataAgendamento"
                        :timePickerProps="{format: '24hr'}"
                        datetime="String"
                    >
                    </v-datetime-picker>
                </v-col>
                <!-- <v-col cols="12">
                    <v-menu
                        v-model="menuAgendamento"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field 
                            v-model="dataAgendamento"
                            label="Agendar Contacto"
                            readonly
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="dataAgendamento" 
                        @input="menuAgendamento = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" text @click="dialog = false">Anular</v-btn>
          <v-btn color="success darken-1" text @click="pushResult">Registar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
    name:'Calls',
    props: [
        "resultados", 
        "lead_process_id", 
        "dataAgendamento",
        "formatDate"
    ],

    data: () => ({
      dialog: false,
      resultado: "",
    //   dataAgendamento: this.props.callback_date,
      menuAgendamento: false
    }),

    created () {
        this.initialize()
    },
    methods: {
        initialize: async function() {
            
        },
        pushResult: async function() {
            let result = this.resultado

            let date = await this.formatDate(this.dataAgendamento)

            let resultado = ""

            for(let i of this.resultados) {
                if(i.value == result) {
                    resultado = i.label
                    
                    continue
                }
            }

            if(!confirm(
              "Estás prestes a registar o seguinte resultado:\n"+resultado+"\n\nPretendes continuar?"
            )) {
            return
          }
          let url = "https://app.reorganiza.pt/public/api/lead-process/new-result/"
          let body = {
            lead_process_id: this.lead_process_id,
            process_step_result: result,
            contact_id: "0",
            username: window.sessionStorage.getItem('username'),
            date
          }

          const res = await this.call_api_post(url, body)

          if(res["resultado"] == "OK") {
            this.$emit('update-history', true)
            this.dialog = false
          }
          else if(res["resultado"] == "KO_FINAL") {
            alert(res["details"])

            this.$emit('update-history-final', true)
            this.dialog = false
          }
          else {
              alert(res["details"])
          }

        },
        call_api_post: async function(url, apiBody) {
            try {
                var response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(apiBody, null, 2)
                })
                var result = await response.json()
                return result
            }
            catch (error) {
                console.error('Error:', error)
                return 'Error: ' + error
            }
        },
    }
}
</script>

<style>

</style>